import { render, staticRenderFns } from "./ai_detail.vue?vue&type=template&id=f353fd68&scoped=true&"
import script from "./ai_detail.vue?vue&type=script&lang=js&"
export * from "./ai_detail.vue?vue&type=script&lang=js&"
import style0 from "./ai_detail.vue?vue&type=style&index=0&id=f353fd68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f353fd68",
  null
  
)

export default component.exports